import { useMemo } from "react";
import { useActiveBrokerAccount } from "../../../hooks/useActiveBrokerAccount";
import type { WorkspaceAccountScope } from "../../../types/workspaceAccountScope";
import { isWorkspaceAccountScopeReady } from "../../../types/workspaceAccountScope";

export function useWorkspaceAccountScope(): {
  scope: WorkspaceAccountScope | null;
  ready: boolean;
  loading: boolean;
} {
  const { activeAccountCode, activeBrokerName, loading } = useActiveBrokerAccount();

  const scope = useMemo<WorkspaceAccountScope | null>(() => {
    if (!activeBrokerName?.trim() || !activeAccountCode?.trim()) return null;
    return {
      brokerName: activeBrokerName.trim(),
      brokerAccountCode: activeAccountCode.trim(),
    };
  }, [activeAccountCode, activeBrokerName]);

  return {
    scope,
    ready: isWorkspaceAccountScopeReady(scope),
    loading,
  };
}
